module.exports = __webpack_public_path__ + "static/img/products1.a6571466.png";